import { AppRemixIcon } from '@/layout/AppComponents';
import { useDispatch, useSelector } from 'react-redux';
import * as currentPageAction from '../../../../../../store/actions/currentPageAction';
import errorHandler from '../../../../../components/error/ErrorHandler';

export default function GGCLObligationCheckbox(props) {
  const { obligationID } = props;
  const dispatch = useDispatch();
  const checkedObligations = useSelector(
    (state) => state.currentPage?.checkedObligations
  );

  // > TOGGLE OBLIGATION CHECKBOX
  const togleCheckbox = async () => {
    const tempCheckedObligations = !checkedObligations
      ? []
      : [...checkedObligations];
    try {
      if (tempCheckedObligations.includes(obligationID)) {
        dispatch(
          currentPageAction.change(
            'checkedObligations',
            tempCheckedObligations.filter((cpo) => cpo !== obligationID),
            true
          )
        );
      } else {
        tempCheckedObligations.push(obligationID);
        dispatch(
          currentPageAction.change(
            'checkedObligations',
            tempCheckedObligations,
            true
          )
        );
      }
    } catch (err) {
      dispatch(errorHandler(err, history));
    }
  };
  // < TOGGLE OBLIGATION CHECKBOX

  return (
    <>
      <AppRemixIcon
        className="pointer"
        icon={
          checkedObligations && checkedObligations.includes(obligationID)
            ? 'checkbox'
            : 'checkbox-blank'
        }
        size={20}
        onClick={() => togleCheckbox()}
      />
    </>
  );
}
